import React from "react";
import {
    Navigate,
} from "react-router-dom";

const ReportListComponent = React.lazy(() => import("../../../../../components/malimax-container/components/list/page"));

export const malimaxReportRoute = [
    {
        path: 'list',
        element: <ReportListComponent />
    },
    {
        path: '',
        element: <Navigate replace to="/form-process/reports/list" />
    },
];